import {CSSProperties as css} from "react";

export const containerCss: css = {
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10,
    paddingTop: 4
};